import React from 'react';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import AcousticCamera3D from '../three/AcousticCamera3D';

export default function Hero() {
  return (
    <section className="relative pt-24 sm:pt-28 pb-16 sm:pb-24 md:pt-36 md:pb-32 overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-50 pointer-events-none" />
      <div className="absolute inset-0 radial-glow pointer-events-none" />

      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12 grid lg:grid-cols-12 gap-8 lg:gap-10 items-center relative">
        <div className="lg:col-span-7 fade-up">
          <div className="eyebrow mb-6">Ultraschall-Leckageortung · ISO 50001</div>

          <h1 className="font-display font-black text-slate-900 tracking-tighter leading-[1.05] text-4xl sm:text-5xl lg:text-6xl">
            Technische Analyse.<br />
            <span className="text-[#0891b2]">Wirtschaftlicher Nachweis.</span>
          </h1>

          <p className="mt-6 sm:mt-7 text-slate-600 text-base sm:text-lg max-w-xl leading-relaxed">
            Aus Messwerten wird Handlungsgrundlage: MIBAX Messtechnik ortet Druckluft- und Prozessgasverluste
            in Industrieanlagen sowie Teilentladungen an Umspannkraftwerken mit visueller Ultraschall-Messtechnik,
            bewertet die Befunde energetisch und ökonomisch und übergibt prüffähige Berichte für Auditor,
            Energiemanagement und Nachhaltigkeitsteam. Aus München — DACH-weit im Einsatz. Volumenstrom (m³/h),
            Energieverlust (kWh/Jahr) und Kosten (€/Jahr) werden CSRD-, EnEfG- und ISO-50001-konform dokumentiert.
          </p>

          <address
            className="mt-7 sm:mt-8 not-italic border-l-2 border-[#0891b2] pl-4 py-1"
            data-testid="hero-contact-block"
          >
            <div className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#0891b2] mb-2">
              Kontakt
            </div>
            <div className="text-slate-900 text-[15px] sm:text-base leading-[1.6]">
              <div className="font-display font-bold">MIBAX Messtechnik</div>
              <div>Inhaber Basic M.</div>
              <div>Tal 44</div>
              <div>80331 München</div>
            </div>
          </address>

          <div className="mt-7 sm:mt-9 flex flex-wrap gap-3 sm:gap-4">
            <a href="#kontakt" className="btn-primary" data-testid="hero-cta-primary">
              Audit anfragen
              <ArrowRight className="w-4 h-4" />
            </a>
            <a href="#roi" className="btn-secondary" data-testid="hero-cta-secondary">
              ROI berechnen
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-6 text-xs font-mono-tech uppercase tracking-[0.2em] text-slate-500">
            <div className="flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-[#0891b2]" />
              ISO 50001 konform
            </div>
            <div className="hidden sm:block w-px h-3 bg-slate-300" />
            <div>Kein Produktionsausfall</div>
            <div className="hidden sm:block w-px h-3 bg-slate-300" />
            <div>TÜV-tauglich</div>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative">
            <div className="absolute -inset-6 bg-[#0891b2]/10 blur-3xl pointer-events-none" />
            <div className="relative border border-slate-200 bg-[#ffffff]/40 backdrop-blur-sm rounded-sm">
              <div className="flex items-center justify-between px-4 py-2 border-b border-slate-200">
                <div className="flex items-center gap-1.5">
                  <span className="w-2 h-2 rounded-full bg-[#ff2a55]" />
                  <span className="w-2 h-2 rounded-full bg-[#ff8a00]" />
                  <span className="w-2 h-2 rounded-full bg-[#00ff66]" />
                </div>
                <div className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-slate-500">
                  MIBAX SCAN.UI · LIVE
                </div>
                <div className="font-mono-tech text-[10px] text-[#0891b2]">REC ●</div>
              </div>
              <AcousticCamera3D />
              <div className="border-t border-slate-200 px-4 py-2.5 flex items-center justify-between font-mono-tech text-[10px] text-slate-500">
                <div>HIGH-END SENSORIK</div>
                <div>REAL-TIME ANALYSE</div>
                <div className="text-[#0891b2]">SIGNAL OK</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
